/**
 * @generated SignedSource<<355b8f7d6c75e1d1e1f8d40ff0321cde>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type plusOpinionContentItemContent$data = {
  readonly __typename: string;
  readonly authors: ReadonlyArray<{
    readonly __typename: "Author";
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"entityLink" | "hooksContentItemProvidersContent">;
  readonly " $fragmentType": "plusOpinionContentItemContent";
};
export type plusOpinionContentItemContent$key = {
  readonly " $data"?: plusOpinionContentItemContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"plusOpinionContentItemContent">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "plusOpinionContentItemContent",
  "selections": [
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Author",
      "kind": "LinkedField",
      "name": "authors",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "withActionBar",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "withAuthorImage",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "withAuthorLink",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "withHeadline",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "withSections",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "withSummary",
          "value": true
        }
      ],
      "kind": "FragmentSpread",
      "name": "hooksContentItemProvidersContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};
})();

(node as any).hash = "7da64db438346cc0918e9021d0757736";

export default node;
